// Constants
import { TYPES } from '../types/types.constants';
import { initialStateApp } from './initial.state';

export const appReducer = (state = initialStateApp, action) => {

    switch (action.type) {

        case TYPES.APP.SET_ERROR:
            return {
                ...state,
                error: action.payload
            }
        case TYPES.APP.RESET_ERROR:
            return {
                ...state,
                error: null
            }
        case TYPES.APP.SET_PAGE_REF:
            return {
                ...state,
                pageRef: action.payload
            }
        case TYPES.APP.RESET_PAGE_REF:
            return {
                ...state,
                pageRef: ''
            }

        case TYPES.APP.SET_GONOGO:
            return {
                ...state,
                gonogo: action.payload
            }
        case TYPES.APP.SET_LOADING:
            return {
                ...state,
                loading: action.payload
            }
        case TYPES.APP.RESET:
            return {
                ...initialStateApp
            }

        default:
            return state;
    }
};